<template>
  <modal :titulo="`Odin - Processamento de Registro Auxiliar - ${titulo}`" id="odin-processamento-registro-auxiliar"
         :fechar="true" @close="close" :loading="loading">

    <template v-if="!loading">

      <card>
        <card-content>

          <p><span class="font-weight-500">{{titulo}}</span></p>
          <p><span class="font-weight-500">CNM: </span><span>{{ficha.cnm}}</span></p>
          <p v-if="ficha.livroLetra"><span class="font-weight-500">Livro (Letra): </span><span>{{ficha.livroLetra}}</span></p>
          <p><span class="font-weight-500">Último Ato: </span><span>{{ficha.ultimoAto}}</span></p>

          <hr/>

          <p><span class="font-weight-500">Atos Registrados no Sistema: </span>
            <span>{{dataBus.info.atosRegistrados}} [Códigos {{dataBus.info.menorAtoRegistrado}} até {{dataBus.info.maiorAtoRegistrado}}]</span></p>
          <p><span class="font-weight-500">Atos Marcados como Validados: </span><span>{{dataBus.info.atosValidados}}</span></p>
          <p><span class="font-weight-500">Atos Sem Texto: </span><span>{{dataBus.info.atosSemTexto}}</span></p>
          <p><span class="font-weight-500">Digitalizações: </span>
            <span>{{dataBus.info.digitalizacoes}}
              <router-link :to="{ name: 'digitalizacao', params: { id: registroAuxiliarId, entidade : 'REGISTRO_AUXILIAR', tipoEntidade : 'REGISTRO_AUXILIAR' }}"
                           target="_blank" title="Digitalização">
                <i class="fal fa-file-image"></i>
              </router-link>
            </span></p>
          <p><span class="font-weight-500">Digitalizações Sem OCR: </span><span>{{dataBus.info.digitalizacoesSemOcr}}</span></p>

        </card-content>
      </card>

      <card class="border-transparent">
        <card-content id="conteudo-processamento">
          <odin-indicador-real-ocr-processamento :data-bus="dataBus" :indicador-real-id="registroAuxiliarId" livro="REGISTRO_AUXILIAR" :textoLegado="textoLegado" />
        </card-content>
      </card>

    </template>

  </modal>
</template>

<script>

import RegistroAuxiliarBusiness from "@/business/indicadores/RegistroAuxiliarBusiness";
import Card from "@/components/Layout/components/Card.vue";
import CardContent from "@/components/Layout/components/CardContent.vue";
import Modal from "@/components/Modal.vue";
import FrontBusiness from "@/business/FrontBusiness";
import OdinIndicadorRealOcrProcessamento from "@/views/Odin/modais/componentes/OdinIndicadorRealOcrProcessamento.vue";

export default {
  name: 'ModalOdinProcessamentoRegistroAuxiliar',
  components: {
    OdinIndicadorRealOcrProcessamento,
    Card, CardContent, Modal},
  props:{
    registroAuxiliarId: String,
    textoLegado: Boolean
  },

  modal: {
    width: 1200
  },
  async mounted() {
    this.load();
  },

  data(){
    return {
      loading: true,
      dataBus: {
        info: null,
        ficha: null,
      }
    }
  },

  computed:{
    titulo(){
      return this.ficha?.livro ? FrontBusiness.nomearFicha(this.ficha) : '';
    },
    ficha(){
      return this.dataBus.ficha;
    }
  },

  methods:{
    async close(retorno) {
      FrontBusiness.closeModal(retorno);
    },

    async load(){

      const p1 = RegistroAuxiliarBusiness.getById(this.registroAuxiliarId)
        .then(r => this.$set(this.dataBus, 'ficha', r));

      const p2 = this.$api.get(`api/odin/acompanhamento-registro-auxiliar/${this.registroAuxiliarId}`)
        .then(r => this.$set(this.dataBus, 'info', r));

      await Promise.all([p1, p2]);

      this.loading = false;
    },

    showError(e) {
      FrontBusiness.showError('', e.message);
    }
  }
}
</script>
